import React from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../../utilities/TabGrid";
import acc from "accounting";
import StatusInTable from "../StatusInTable";
import BiletyService from "../../../biletyApi/BiletyService";

const BKBiletyPozycje = ({bilet, statusy, wyswietlNotyfikacje}) => {


    const renderKod = (cell, row) => {
        // gdy bilet jest połączonym
        if (Boolean(row.idBiPow)) {
            return (
                <div>
                    <div>
                        <span className={'label label-ebus-primary'}>{row.idBi}</span>
                    </div>
                    <div style={{marginTop: '2px'}}>
                        <span className={'label label-ebus-secondary'}
                        >{row.idBiPow}</span>
                    </div>
                </div>
            )
        }// gdy jest podstawowym albo nie ma połączeń
        else {
            return (<div>
                <span className={'label label-ebus-primary'}>{row.idBi}</span>
            </div>)
        }
    }

    const renderZnizka = (cell, row) => {
        return (<div>
            <span className={'label label-ebus-default'} style={{color: '#fff', background: row.kolor}}>{cell}</span>
            <span style={{marginLeft: '5px'}}>{row.nazZniz}</span>
        </div>)
    }

    const renderOdcinek = (cell, row) => {
        return (<div>
            {row.nazMiOd + ' ' + row.nazPrOd} <i className={'fa fa-long-arrow-right'}></i> {row.nazMiDo + ' ' + row.nazPrDo}
        </div>)
    }

    const renderCena = (cell, row) => {

        return <div>
            <span>{acc.formatMoney(row.cena * row.ile)}</span>
            {// jesli dana cena byla promocyjna
                Boolean(row.idPro) ?
                    <span style={{marginLeft: '7px', color: '#132239', background: '#eee'}} className={'label label-ebus-secondary'}
                          title={'Cena promocyjna'}><i className={'fa fa-tag'}></i> {row.idPro}</span>
                    : ''
            }
            <div style={{fontSize: '12px', color: 'grey'}}>
                {acc.formatMoney(row.cena)}/szt
            </div>
        </div>
    }

    const renderStatusy = (cell, row) => {

        let status = statusy.find(s => s.value == cell)
        let formaplat = ''
        if (row.formaPlatn == 'GK') formaplat = 'gotówka'
        if (row.formaPlatn == 'KK') formaplat = 'karta'
        if (row.formaPlatn == 'PR') formaplat = 'przelew'
        if (Boolean(status)) {
            return <div>
                <StatusInTable status={status}
                               idBp={row.idBp}
                               statusy={statusy}
                               handleSelectStatus={(e) => handleSelectStatus(e, row)}
                />
                {
                    row.statPoz === 2 || row.statPoz === -2 || row.statPoz === -4 ?
                        <div>
                            {
                                (row.statPoz === 2) ?
                                    <div style={{
                                        marginTop: '1px',
                                        marginLeft: '10px',
                                        color: 'grey',
                                        fontStyle: 'italic',
                                        fontSize: "12px"
                                    }}>Skasował: {(row.skasowalKierowca) ? row.skasowalKierowca : "-"}</div>
                                    :
                                    ""
                            }
                            {
                                (row.statPoz === -2) ?
                                    <div style={{
                                        marginTop: '1px',
                                        marginLeft: '10px',
                                        color: 'grey',
                                        fontStyle: 'italic',
                                        fontSize: "12px"
                                    }}>Anulowano: {(row.anulowanoData) ? row.anulowanoData.replace("T", " ").substr(0, 19) : "-"}</div>
                                    :
                                    ""
                            }
                            {
                                (row.statPoz === -4) ?
                                    <div style={{
                                        marginTop: '1px',
                                        marginLeft: '10px',
                                        color: 'grey',
                                        fontStyle: 'italic',
                                        fontSize: "12px"
                                    }}>Zwrot: {(row.zwrotProc) ? row.zwrotProc + "%" : "-"}, {(row.zwrotKwota) ? row.zwrotKwota + " zł" : "-"}</div>
                                    :
                                    ""
                            }
                        </div>
                        :
                        <div style={{marginTop: '1px', marginLeft: '10px', color: 'grey', fontStyle: 'italic', fontSize: "12px"}}>{formaplat}</div>

                }
            </div>
        }
    }

    const handleSelectStatus = (status, obj) => {
        BiletyService.editStatusWJednorazowym(obj.idBp, parseInt(status.value)).then(function (response) {
            if (response.status < 300) {
                wyswietlNotyfikacje('Pomyślnie zmieniono status biletu', true)
            }
            else {
                wyswietlNotyfikacje('Wystąpił błąd podczas zmiany statusu', false)
            }
        }.bind(this))
    }

    return (
        <div>
            <BootstrapTable data={bilet.biletyPoz}
                            hover
            >
                <TableHeaderColumn dataField='idBi' isKey hidden={false} thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                   dataFormat={renderKod}
                >Kod</TableHeaderColumn>
                <TableHeaderColumn dataField='waznyOd'
                                   thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                >Ważny w</TableHeaderColumn>
                <TableHeaderColumn dataField='godz'
                                   thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                   dataFormat={(cell, row) => row.godz.replace('.', ':')}
                >Godz.</TableHeaderColumn>
                <TableHeaderColumn dataField='idMiOd'
                                   thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                   dataFormat={renderOdcinek}
                >Odcinek</TableHeaderColumn>
                <TableHeaderColumn dataField='klient'
                                   thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                   dataFormat={(cell, row) => {
                                       return <div>
                                           <div>{row.nazKl}</div>
                                           <div style={{fontWeight: "bold"}}>{cell}</div>
                                       </div>
                                   }}
                >Pasażer</TableHeaderColumn>
                <TableHeaderColumn dataField='ile'
                                   thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                >Ilość</TableHeaderColumn>
                <TableHeaderColumn dataField='cena'
                                   thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                   dataFormat={renderCena}
                >Wartość</TableHeaderColumn>
                <TableHeaderColumn dataField='rodz'
                                   thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                   dataFormat={renderZnizka}
                >Zniżka</TableHeaderColumn>
                <TableHeaderColumn dataField='statPoz' dataSort
                                   thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                   dataFormat={renderStatusy}
                >Status</TableHeaderColumn>


            </BootstrapTable>
        </div>
    );
};

export default BKBiletyPozycje;


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/biletyJednorazowe/components/bilety_kod_z_paragonu_components/BKBiletyPozycje.js